export const cardImage = {
    showRoundedCardImage: {
        enabled: false,
        _description: 'Displays rounder borders with shadow around the card image.',
    },
};
